<uc-main-header
	[heading]="categoryDetails.headerTitle"
	[description]="categoryDetails.headerDescription"
	backgroundStyle="bg-advice"
>
	<a
		class="flex justify-center sm:inline-flex gap-2 !pl-2 pr-6 mt-6 white-header-btn btn-py-2"
		routerLink="/advice"
	>
		<uc-arrow-left-svg customStyles="!w-4 !h-4 pt-1" />
		Back to Articles
	</a>
</uc-main-header>

<!-- advice about -->
<div class="container bg-white">
	<div class="divider">
		<h2 class="secondary-header">
			{{ categoryDetails.aboutTitle }}
		</h2>
		<p class="max-w-screen-xl text-base">
			<span [innerHTML]="categoryDetails.aboutDescription"> </span>
			@if (categoryDetails.showReadMoreButton && viewReady) {
				@if (!showReadMoreText) {
					<span>...</span>
				}
				<button
					[ngClass]="{ 'ml-1': showReadMoreText }"
					class="cursor-pointer only-tab-focus blue-link-underline"
					(click)="showMoreText()"
				>
					{{ showReadMoreText ? 'read less' : 'read more' }}
				</button>
			}
		</p>
	</div>
</div>

<!-- Loading -->
@if (loadingForData) {
	<div class="container divider">
		<uc-loading-animation [htmlString]="loadingHtml" />
	</div>
}
@if (articles$ | async) {
	<div class="container">
		<!-- featured -->
		@if (featured?.featured_article?.art_id) {
			<div class="divider">
				<h2 class="secondary-header">Featured Article</h2>
				<uc-advice-featured-card [article]="featured.featured_article" />
			</div>
		}
		<!-- snigel -->
		<div class="divider">
			<div class="sm:hidden">
				<div
					id="adngin-incontent_1_mob-0"
					class="mx-auto incontent_1_mob-0"
				></div>
			</div>
			<div class="hidden sm:block">
				<div
					id="adngin-incontent_1_dskt-0"
					class="mx-auto incontent_1_dskt-0"
				></div>
			</div>
		</div>
		@if (articles) {
			@if (articles[categoryDetails.key]?.length > 0) {
				<div class="divider">
					<h2 class="secondary-header">
						{{ categoryDetails.articlesTitle }}
					</h2>
					<!-- all articles-->
					<div
						class="grid max-w-screen-xl gap-6 mx-auto sm:grid-cols-2 md:grid-cols-3"
					>
						@for (article of articles[categoryDetails.key]; track article) {
							<uc-advice-article-card [article]="article" />
						}
					</div>
				</div>
			}
			<!-- related categories -->
			<div class="divider-top md:grid md:grid-cols-3 md:gap-10 lg:gap-20">
				<div class="md:col-span-2">
					@if (articles) {
						<uc-table-search
							heading="Related Categories"
							[resultCount]="relatedCategories.length"
							[showSearch]="false"
						>
							@for (
								category of relatedCategories;
								track category.key;
								let last = $last
							) {
								<uc-advice-category-card
									[categoryName]="category.catTitle"
									[categoryDesc]="category.catDescription"
									[categorySlug]="category.url"
									[isLast]="last"
									[articleCount]="articles[category.key]?.length ?? 0"
								/>
							}
						</uc-table-search>
					}
				</div>

				<div
					class="pt-8 pb-8 mt-8 border-t border-b md:border-b-0 md:pt-0 md:mt-0 md:border-0 md:col-span-1 md:block"
				>
					<div class="sticky top-8">
						<uc-promo-slot-cta-card />
					</div>
				</div>
			</div>
		}
		<!-- promo slots -->
		<uc-promo-slots headline="Find the latest from Uni Compare" [section]="1" />
	</div>
}

<uc-sticky-lead-bar-renderer leadType="BOOK_EVENT" colorScheme="ROSE" />
